import React from 'react';
import { ModalV2, ModalTitle } from '../../../../../core/components';
import { CoilsProps, ExperimentConfiguration, IAnatomicalModel } from '../../../models';
import { B0StrengthSection } from './b0-strength-section';
import { CoilSection } from './coil-section';
import { MaxGradientStrengthSection } from './max-gradient-strength-section';

export interface ModalProps {
  config: ExperimentConfiguration[];
  additionalCoils: CoilsProps[];
  anatomicalModel: IAnatomicalModel;
  onClose: VoidFunction;
  updateScannerSettings: (action: string, value: string, configurationName: string) => void;
}

export const ScannerSettingsModal: React.FC<ModalProps> = ({
  onClose,
  config,
  updateScannerSettings,
  additionalCoils,
}: ModalProps): React.ReactElement => {
  return (
    <ModalV2
      withCloseButton
      closeOnOutsideClick
      onClose={onClose}
      header={<ModalTitle>Scanner settings</ModalTitle>}
      style={{ width: '1024px' }}
    >
      <>
        <CoilSection config={config} setCoilType={updateScannerSettings} additionalCoils={additionalCoils} />
        <B0StrengthSection config={config} setB0Strength={updateScannerSettings} />
        <MaxGradientStrengthSection config={config} setMaxGradientStrength={updateScannerSettings} />
      </>
    </ModalV2>
  );
};
